import { fetchData } from "./fetch";

export const createCampaign = (data) => fetchData('POST', '/campaigns', data);

export const getCampaigns = () => fetchData('GET', '/campaigns');

export const removeCampaign = (id) => fetchData('DELETE', `/campaigns/${id}`);

export const getCampaignById = (id) => fetchData('GET', `/campaigns/${id}`);

export const getInfluencersByCampaignId = ({ id, data }) => fetchData('GET', `/campaigns/${id}/influencers`, data);

export const runCampaign = (id) => fetchData('POST', `/campaigns/${id}/run`);

export const pauseCampaign = (id) => fetchData('POST', `/campaigns/${id}/pause`);

export const getInfluencerByCampaignId = (id) => fetchData('GET', `/campaigns/influencers/${id}`);

export const getInfluencersInCampaigns = (data) => fetchData('GET', `/campaigns/influencers/search/`, data);
